if (!customElements.get('mega-menu-products')) {
  customElements.define(
    'mega-menu-products',
    class MegaMenuProducts extends HTMLElement {
      connectedCallback() {
        this.buttons = this.querySelectorAll('[data-mega-category-trigger]');
        this.panels = this.querySelectorAll('[data-mega-category-panel]');
        if (!this.buttons.length) return;

        this.buttons.forEach((button) => {
          const activate = () => this.setActive(button.dataset.megaCategoryTrigger);
          button.addEventListener('mouseenter', activate);
          button.addEventListener('focus', activate);
        });
      }

      setActive(id) {
        this.buttons.forEach((button) => {
          const on = button.dataset.megaCategoryTrigger === id;
          button.classList.toggle('is-active', on);
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.megaCategoryPanel !== id;
        });
      }
    }
  );
}
